import React from 'react';

export default function Logo() {
  return (
    <svg height="200" width="200" viewBox="25 10 60 60">
      <path
        d="M48 10 l 6 0 l 0 10 l 15 0 a 10 10 0 1 1 0 20
  a 10 10 0 1 1 0 20 l -15 0 l 0 10 l -6 0 l 0 -10 l -10 0 l 0 -6 l 28 0 a 6 5 0 1 0 0 -11 l -6 0 l 0 -6 l 6 0 a 6 5 0 1 0 0 -11 l -28 0 l 0 -6 l 10 0 Z"
        stroke="none"
        fill="#93E9BE"
      />
      Sorry, your browser does not support inline SVG.
    </svg>
  );
}
